export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./highlights-menu.vue?vue&type=template&id=8c80d082"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/highlights-menu/highlights-menu.vue?vue&type=template&id=8c80d082
// module id = 2uLR
// module chunks = 0